export class PerformanceTimer {
  private start = performance.now();

  constructor(private readonly name: string) {}

  stop() {
    const time = performance.now() - this.start;
    console.log(
      `Timer [${this.name}]: start ${this.start}ms, took ${Math.round(time)}ms`
    );
  }

  restart() {
    this.start = performance.now();
  }
}
